<script>
export default {
  $_veeValidate: {
    name() {
      return this.name ? this.name : this.label;
    },
    value() {
      return this.value;
    }
  },

  props: {
    value: [String, Number],
    label: String,
    name: { type: String, required: false, default: null },
    type: { type: String, required: false, default: "text" },
    error: { type: String, required: false },
    mask: { type: [String, Array], required: false, default: "" },
    masked: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false }
  },

  data() {
    return {
      id:
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9)
    };
  }
};
</script>

<template>
  <div class="group" :class="{'with-error': error}">
    <div v-if="error" class="error">{{error}}</div>

    <input
      v-if="!mask"
      :id="id"
      :value="value"
      :type="type"
      :disabled="disabled"
      placeholder="."
      @keyup.enter="$emit('keyupEnter')"
      @keyup="$emit('keyup')"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @input="$emit('input', $event.target.value)"
    />
    <the-mask
      v-else
      :id="id"
      :value="value"
      :type="type"
      :mask="mask"
      :masked="masked"
      :disabled="disabled"
      placeholder="."
      @keyup.enter="$emit('keyupEnter')"
      @keyup="$emit('keyup')"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @input="$emit('input', $event)"
    />
    <label :for="id">{{label}}</label>
  </div>
</template>

<style lang="scss" scoped>
.group {
  display: flex;
  height: 45px;
  margin-top: 8px;
  flex-flow: column-reverse;
  flex-grow: 1;

  input {
    flex: 1;
    margin: 0 5px;
    z-index: 1;
    background-color: transparent;
    padding-left: 2px;
    border: none;
    transition: all 0.5s ease;
    min-height: 25px;
    border-bottom: 1px solid #b8b8b8;
    font-weight: 400;
    color: #333;

    &::placeholder {
      opacity: 0;
    }

    &:focus,
    &:not(:placeholder-shown) {
      + label {
        transform-origin: left bottom;
        transform: translateY(0px) scale(0.85);
      }
    }

    &:focus {
      border-bottom: 2px solid $purple;
      + label {
        color: $purple;
      }
    }

    &[disabled],
    &[disabled]:focus + label,
    &[disabled]:not(:placeholder-shown) + label {
      color: #999;
      cursor: default;
    }
  }

  label {
    margin-left: 6px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    transition: all 0.25s ease;
    cursor: text;
    transform-origin: left bottom;
    transform: translateY(20px) scale(1);
    z-index: 1;
    user-select: none;
  }

  &.with-error {
    height: 60px;

    label {
      color: $pink;
    }

    input {
      border-bottom: 1px solid $pink;
      color: $pink !important;

      &:focus {
        border-bottom: 2px solid $pink;
        + label {
          color: $pink;
        }
      }
    }
  }

  .error {
    font-size: 11px;
    color: $pink;
    padding-left: 5px;
    padding-top: 3px;
    height: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Input.vue